export type SymbolMap = Record<string, string>;

// Used before the countries API responds or on fetch error
export const FALLBACK_SYMBOL_MAP: SymbolMap = {
  usd: '$', cad: 'CA$', gbp: '£', eur: '€', aud: 'A$', nzd: 'NZ$', zar: 'R',
};

export function buildSymbolMap(
  countries: { currency_code: string; currency_symbol: string }[],
): SymbolMap {
  const map: SymbolMap = {};
  for (const c of countries) {
    if (c.currency_symbol) map[c.currency_code.toLowerCase()] = c.currency_symbol;
  }
  return map;
}

export function currencySymbol(
  code: string | null | undefined,
  map: SymbolMap = FALLBACK_SYMBOL_MAP,
): string {
  const key = (code ?? 'usd').toLowerCase();
  return map[key] ?? FALLBACK_SYMBOL_MAP[key] ?? (code ?? 'USD').toUpperCase();
}
